import {combineReducers, createReducer} from '@reduxjs/toolkit';

import {DRAWERS, TOURS, UI_MODES} from '../constants/index.js';
import {clearActiveFolder} from '../actions/folders.js';
import {executeSearch, saveGeometry} from '../actions/search.js';
import {
  hideModal,
  resize,
  setMode,
  setSaveErrors,
  showLeftDrawer,
  showModal,
  showRightDrawer,
} from '../actions/ui.js';
import {resetTour, setTour} from '../actions/tour.js';

export const size = createReducer({width: NaN, height: NaN}, builder => {
  builder.addCase(resize, (state, {payload: {width, height}}) => {
    state.width = width;
    state.height = height;
  });
});

const initialDrawerState = {
  left: '',
  right: '',
};

export const drawers = createReducer(initialDrawerState, builder => {
  builder.addCase(showLeftDrawer, (state, {payload}) => {
    state.left = payload;
  });

  builder.addCase(showRightDrawer, (state, {payload}) => {
    state.right = payload;
  });

  builder.addCase(clearActiveFolder, state => {
    if (
      state.right === DRAWERS.COLORENHANCE ||
      state.right === DRAWERS.PROCESS
    ) {
      state.right = '';
    }
    return state;
  });

  builder.addCase(resetTour, (state, {payload}) => {
    if (payload !== TOURS.OVERZOOM) {
      return initialDrawerState;
    }
    return state;
  });

  builder.addCase(
    saveGeometry,
    (state, {payload: {geometryTooLarge, fromHash}}) => {
      if (!geometryTooLarge && !fromHash) {
        state.left = DRAWERS.SEARCH;
      }
    }
  );

  builder.addCase(executeSearch, (state, {payload: suggestion}) => {
    if (suggestion) {
      state.left = DRAWERS.SEARCH;
    }
  });
});

export const modal = createReducer(null, builder => {
  builder.addCase(showModal, (state, {payload}) => payload);
  builder.addCase(hideModal, () => null);
});

const initialMode = UI_MODES.BROWSE;

const mode = createReducer(initialMode, builder => {
  builder.addCase(setMode, (state, {payload}) => payload);

  builder.addCase(showLeftDrawer, (state, {payload}) => {
    if (payload === DRAWERS.FOLDERS) {
      return initialMode;
    }
    return state;
  });

  builder.addCase(setTour, (state, {payload}) => {
    if (payload !== TOURS.OVERZOOM) {
      return initialMode;
    }
    return state;
  });

  builder.addCase(resetTour, (state, {payload}) => {
    if (payload !== TOURS.OVERZOOM) {
      return initialMode;
    }
    return state;
  });
});

const saveState = createReducer(
  {
    errors: [],
  },
  builder => {
    builder.addCase(setSaveErrors, (state, {payload}) => {
      state.errors = payload;
    });
  }
);

export default combineReducers({
  size,
  mode,
  modal,
  drawers,
  saveState,
});
